import util from '../util'

let controller = 'DadosCM'
export default {
  GetFinalidadeIF: function () {
    return util.Axios.Get(controller + '/FinalidadeIF')
  },
  GetDominio: function (tipo) {
    return util.Axios.Get(controller + '/Dominio', tipo)
  }
}
